module.exports = __webpack_public_path__ + "static/media/prettier.fb434f2d.svg";